import React from "react";
import SubHeader from "../general/SubHeader";
import Niraj from "../../assets/member/NirajPandey.png";

const NirajPandey = () => {
  return (
    <>
      <SubHeader message="Members" />

      <section className="my-5">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>Members</span>
            <hr />
          </div>
          <p className="sec-heading">Our Management Group</p>

          <div className="member-area row mt-5">
            <div className="col-lg-4 col-12 my-3 pe-lg-0">
              <img
                src={Niraj}
                className="img-fluid border-0 rounded"
                alt="Agents"
              />
            </div>

            <div className="col-lg-8 col-12 my-3 text-muted">
              <div className="member-info">
                <p className="fw-bold fs-5 my-0 text-dark">Niraj Pandey</p>
                <span>Project Manager</span>
                <br />
                {/* <p className='mt-3 para-text fw-bold'>
                                Education: MA (ENGLISH) , B. ED, D. PHARMA<br />
                                Experience: SOCIAL WORKER, SANSTHAPAK NGO KATKA CLUB SAMAJIK SANSTHA (REGD.), Wholesale medicine supplier<br />
                                Achievement: Asia book of World Record holder, achieved various certificates in social work activities</p> */}

                <p className="mt-3">
                  Niraj Pandey is a skilled and experienced Project Manager at
                  Swalok Group, where he plays a crucial role in overseeing and
                  executing various projects within the organization. With a
                  strong foundation in project management principles and a
                  proven track record of successful project delivery, Niraj has
                  become an integral part of the team. He is responsible for
                  coordinating resources, managing timelines, and ensuring that
                  projects are completed efficiently and within budget.
                  <br />
                  <br />
                  In addition to his technical expertise, Niraj is known for his
                  excellent communication skills, which help him facilitate
                  collaboration between stakeholders and team members. His
                  leadership and ability to adapt to changing project
                  requirements have consistently delivered results that align
                  with the strategic goals of the organization.
                  <br />
                  <br />
                  With a passion for delivering high-quality projects, Niraj
                  continuously strives for excellence in every aspect of his
                  work. His dedication to achieving optimal outcomes and his
                  focus on client satisfaction have significantly contributed to
                  the success and growth of Swalok Group. As Project Manager,
                  Niraj Pandey continues to drive the group’s projects forward,
                  ensuring their success and aligning them with the company’s
                  broader objectives.
                </p>
              </div>
            </div>
          </div>
          {/* row ends */}
        </div>
      </section>
    </>
  );
};

export default NirajPandey;
